import { useState } from 'react';
import { MdHelp, MdNotificationsNone } from 'react-icons/md';
import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/services/axios.service';
import { GenericResponse, ListResponse } from '@/common/common_utils';
import { ENDPOINTS } from '@/constants/endpoints';
import { getFrontendConfig } from '@/modules/config/engine/frontend-config';
import NotificationPanel from '../notification/NotificationPanel';
import UserDropdown from '../user/UserDropDown';
import { NotificationResponse } from '../notification/NotificationResponse';
import HeaderIconButton from './HeaderIconButton';
import './header.styles.css';

const HeaderActions = () => {
	const notificationsQ = useQuery({
		queryKey: ['NotificationPanel.notifications'],
		queryFn: async () => {
			const result = await axiosInstance.post<GenericResponse<ListResponse<NotificationResponse>>>(ENDPOINTS['/api/X4bUser/GetNotifications'], {});
			return result.data.Data;
		}
	});
	const publicConfigQ = useQuery({
		queryKey: ['Header.config'],
		queryFn: async () => {
			const result = await getFrontendConfig();
			return result.data;
		}
	});
	const notifications = (notificationsQ.isSuccess && notificationsQ.data.Items.length > 0 ? notificationsQ.data.Items : []);
	const helpUrl = publicConfigQ.data?.HelpUrl ?? '';
	const hasNotifications = notifications.length > 0;
	const [activePanel, setActivePanel] = useState<'notifications' | null>(null);
	const [userMenuOpen, setUserMenuOpen] = useState(false);

	const togglePanel = (panel: 'notifications') => {
		setActivePanel((prev) => (prev === panel ? null : panel));
		setUserMenuOpen(false);
	};

	const openHelp = () => {
		if (!helpUrl) return;

		const helpWindow = window.open(helpUrl, '_blank', 'noopener,noreferrer');
		helpWindow?.focus();
	};

	const toggleUserMenu = () => {
		setUserMenuOpen((prev) => !prev);
		setActivePanel(null);
	};

	return (
		<div className="actions relative">
			<HeaderIconButton
				ariaLabel="Help"
				label="Help"
				icon={<MdHelp size={24} className="text-primary" />}
				onClick={openHelp}
				disabled={!helpUrl}
			/>
			<HeaderIconButton
				ariaLabel="Notifications"
				onClick={() => togglePanel('notifications')}
				icon={
					<div className="relative">
						<MdNotificationsNone size={24} className="text-primary" />
						{hasNotifications && <span className="notification-badge" />}
					</div>
				}
			/>
			{activePanel === 'notifications' && (
				<NotificationPanel
					isOpen
					onClose={() => setActivePanel(null)}
					notifications={notifications}
				/>
			)}
			<div className="relative">
				<HeaderIconButton
					ariaLabel="Account"
					onClick={toggleUserMenu}
					className="overflow-hidden p-0 transition hover:brightness-95"
					icon={<img src="/images/concierge/user-avatar2.png" alt="" className="h-10 w-10 rounded-full object-cover" />}
				/>
				{userMenuOpen && <UserDropdown />}
			</div>
		</div>
	);
};

export default HeaderActions;
